import axios, { AxiosError } from 'axios'
import { useState, useEffect, useCallback } from 'react'
import { API_BRANDS } from '../consts'

export interface Brand {
  id: number
  name: string
  company_id: number | null
  logo_url: string | null
  catalog_status: string
  uuid: string
  aliases: string[]
}

export const useBrand = (id: number | null) => {
  const [state, setState] = useState<{
    currentBrand: Brand | null
    error: AxiosError | null
    isLoading: boolean
  }>({
    currentBrand: null,
    error: null,
    isLoading: false,
  })
  const fetchBrand = useCallback(async () => {
    if (!id) {
      setState({ error: null, currentBrand: null, isLoading: false })
      return
    }

    try {
      setState((state) => ({ ...state, isLoading: true }))
      const response = await axios.get(`${API_BRANDS}/${id}`)

      setState({ currentBrand: response.data, error: null, isLoading: false })
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setState({ currentBrand: null, error: err, isLoading: false })
      }
    }
  }, [id])

  useEffect(() => {
    fetchBrand()
  }, [fetchBrand])

  return { ...state, refresh: fetchBrand }
}
